import { component } from 'picoapp';
import Drawer from 'utils/drawer';

export default component(async (node) => {
  const backButton:HTMLElement = node.querySelector('[data-back]');
  const closeButton:HTMLElement = node.querySelector('[data-close]');
  const quickfinderButtons:NodeListOf<HTMLElement> = document.querySelectorAll('[data-quickfinder]');
  const drawer = Drawer(node);
  const quickfinderBrands = node.querySelectorAll('[data-brand]');

  const searchInputs:NodeListOf<HTMLInputElement> = node.querySelectorAll('[data-search]');
  searchInputs.forEach((input) => {
    const searchQuery = input.dataset.search.toLowerCase();
    const searchItems:NodeListOf<HTMLLIElement> = node.querySelectorAll(`[data-search-item="${searchQuery}"]`);
    input.addEventListener('keyup', () => {
      searchItems.forEach((item) => {
        item.hidden = false;
        if (!item.dataset.searchTerm.includes(input.value.toLowerCase())) {
          item.hidden = true;
        }
      });
    });
  });

  quickfinderBrands.forEach((brand) => {
    brand.addEventListener('click', () => {
      brand.parentElement.parentElement.setAttribute('data-active', 'true');
      brand.setAttribute('data-active', 'true');
      backButton.hidden = false;
    });
  });

  backButton.addEventListener('click', () => {
    node.querySelectorAll('[data-active]').forEach((element) => {
      element.setAttribute('data-active', 'false');
    });
    backButton.hidden = true;
  });

  closeButton.addEventListener('click', () => {
    drawer.close();
  });

  const quickfinderInit = (device) => {
    const menu:HTMLElement = node.querySelector(`[data-device="${device}"]`);
    menu.hidden = false;
  };

  quickfinderButtons.forEach((button) => {
    button.addEventListener('click', () => {
      quickfinderInit(button.dataset.quickfinder);
      drawer.open();
    });
  });

  drawer.on('open', async () => {
    const disableScroll = (await import(
      /* webpackChunkName: "scroll-lock" */
      'modules/scroll-lock'
    )).default.disablePageScroll;
    disableScroll(node);
  });

  drawer.on('closed', async () => {
    const enableScroll = (await import(
      /* webpackChunkName: "scroll-lock" */
      'modules/scroll-lock'
    )).default;

    enableScroll.clearQueueScrollLocks();
    enableScroll.enablePageScroll(node);

    node.querySelectorAll('[data-device]').forEach((element:HTMLElement) => {
      element.hidden = true;
    });
    node.querySelectorAll('[data-active]').forEach((element) => {
      element.setAttribute('data-active', 'false');
    });
    backButton.hidden = true;

    const searchItems:NodeListOf<HTMLLIElement> = node.querySelectorAll('[data-search-item]');
    searchItems.forEach((item) => {
      item.hidden = false;
    });

    searchInputs.forEach((input) => {
      input.value = '';
    });
  });
});
